import { css } from "@emotion/css";
import styled from "@emotion/styled";

export const StyledContent = styled.div`
    padding: 50px;
`;

export const loaderClass = css`
    &&&& {
        max-height: none;
    }
`;
